<template>
  <v-container class="fill-height login" fluid>
    <v-row justify="center">
      <v-col cols="12" lg="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>{{ $t("reset_password") }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form v-model="valid">
              <v-row no-gutters>
                <v-col cols="12">
                  <text-field
                    v-model="email"
                    :rules="[rules.required, rules.email]"
                    :placeholder="$t('email_pass_reset_link')"
                  >
                  </text-field>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed large :to="{ name: 'auth-login' }">
                  {{ $t("back") }}
                </v-btn>

                <v-spacer></v-spacer>
                <primary-button
                  :loading="loading"
                  :disabled="!valid"
                  :dark="valid"
                  @click="reset"
                >
                  {{ $t("save") }}
                </primary-button>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import userService from "@/services/user";

export default {
  mixins: [hasValidation, hasSnackbar],
  data: () => ({
    email: "",
    loading: false,
    valid: false,
  }),
  methods: {
    reset() {
      this.loading = true;
      userService
        .sendForgotPasswordEmail(this.email)
        .then(() => {
          this.showSuccessSnackbar(this.$t("password_reset_link_sent"));
          this.loading = false;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("password_reset_link_sent"));
          this.loading = false;
        });
    },
  },
};
</script>
